(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .service('ShowcaseLayoutTemplateService', ShowcaseLayoutTemplateService);

    ShowcaseLayoutTemplateService.$inject = ['ShowcaseLayoutTemplateFactory', '$q'];

    function ShowcaseLayoutTemplateService(ShowcaseLayoutTemplateFactory, $q) {
        var TemplateResource = ShowcaseLayoutTemplateFactory.TemplateResource;
        var ComponentResource = ShowcaseLayoutTemplateFactory.ComponentResource;
        var ViewComponentResource = ShowcaseLayoutTemplateFactory.ViewComponentResource;
        var StoreBannerResource = ShowcaseLayoutTemplateFactory.StoreBannerResource;

        return {
            list: list,
            get: get,
            create: create,
            update: update,
            remove: remove,
            setStatus: setStatus,
            getViewComponents: getViewComponents,
            getComponentsByTemplate: getComponentsByTemplate,
            deleteComponent: deleteComponent,
            listStoreBanners: listStoreBanners,
            listStoreBannersByIds: listStoreBannersByIds,
            createStoreBanner: createStoreBanner
        };

        function list(pageable, search) {
            var deferred = $q.defer();
            var params = {
                page: pageable.page,
                size: pageable.size,
                search: search || '',
                sort: pageable.sort || 'lastModifiedDate,desc'
            };

            TemplateResource.query(params, function (data, headers) {
                deferred.resolve({
                    data: data,
                    headers: data.$headers || headers
                });
            }, function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function get(id) {
            return TemplateResource.get({ id: id }).$promise;
        }

        function create(payload) {
            return TemplateResource.create(payload).$promise;
        }

        function update(id, payload) {
            return TemplateResource.update({ id: id }, payload).$promise;
        }

        function remove(id) {
            var deferred = $q.defer();
            TemplateResource.delete({ id: id }, function () {
                deferred.resolve();
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function setStatus(id, status) {
            return TemplateResource.setStatus({ id: id, status: status }).$promise;
        }

        function getViewComponents() {
            return ViewComponentResource.getAll().$promise;
        }

        function getComponentsByTemplate(templateId, pageable) {
            var deferred = $q.defer();
            var params = {
                templateId: templateId,
                page: pageable.page || 0,
                size: pageable.size || 200,
                search: pageable.search || ''
            };

            ComponentResource.queryByTemplate(params, function (data) {
                deferred.resolve(data);
            }, function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function deleteComponent(componentId) {
            return ComponentResource.delete({ componentId: componentId }).$promise;
        }

        function listStoreBanners(pageable, search) {
            var deferred = $q.defer();
            var params = {
                page: pageable.page,
                size: pageable.size,
                search: search || '',
                sort: pageable.sort || 'id,desc'
            };

            StoreBannerResource.list(params, function (data, headers) {
                deferred.resolve({
                    data: data,
                    headers: data.$headers || headers
                });
            }, function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function listStoreBannersByIds(ids) {
            if (!ids || !ids.length) {
                return $q.resolve([]);
            }
            return StoreBannerResource.listByIds({ ids: ids.join(',') }).$promise;
        }

        function createStoreBanner(payload) {
            return StoreBannerResource.create(payload).$promise;
        }
    }

})();
